import BenefitManagementStore from "stores/BenefitsManagementStore";
import {Formik} from "formik";

import "./BenefitsDetailForm.scss";

import React from "react";
import {Benefit} from "models/Benefit";
import DataForm from "../BenefitForm/BenefitForm";
import DeleteButton from "./components/DeleteButton";


const BenefitDetailForm = () => {
  const { benefit } = BenefitManagementStore;

  const handleSubmit = (values: Benefit) => {
    BenefitManagementStore.putBenefit(values)
  }

  return (
    <div className="c-benefit-form">
      <DeleteButton />
      <Formik initialValues={benefit} onSubmit={handleSubmit} component={DataForm} />
    </div>
  )
}


export default BenefitDetailForm;